import React from 'react';
import { useTranslation } from 'react-i18next';
import LOCALS from 'commons/locals';

type VarianceStatusProps = {
  variance: number;
  actualCash: number;
  currencySymbol: string;
  formatAmount: (amount: number | null | undefined) => string;
};

const VarianceStatus: React.FC<VarianceStatusProps> = ({
  variance,
  actualCash,
  currencySymbol,
  formatAmount,
}) => {
  const { t } = useTranslation();

  if (actualCash <= 0) {
    return null;
  }

  if (variance !== 0) {
    return (
      <div className="p-5 rounded-lg border-2 bg-red-50 border-red-200">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <span className="mr-4 text-2xl text-red-600">⚠️</span>
          </div>
          <span className="text-xl font-bold text-red-600">
            {currencySymbol} {formatAmount(Math.abs(variance))}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="p-5 rounded-lg border-2 bg-green-50 border-green-200">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <span className="mr-4 text-2xl text-green-600">✅</span>
          <span className="text-lg font-medium text-green-700">
            {t(LOCALS.daily_register_close_cash_count_matched)}
          </span>
        </div>
        <span className="text-xl font-bold text-green-600">
          {t(LOCALS.daily_register_close_no_over_short)}
        </span>
      </div>
    </div>
  );
};

export default VarianceStatus;
